module.exports = __webpack_public_path__ + "static/bathroom3-43f9ea12b4acbcc0d58f69c1e1362999.jpg";